import React from 'react'
import { connect } from 'react-redux'
import Page from '../../component/page'
import PlayersList from './PlayersList'

function Players({ players = [] }) {
  return (
    <Page className="players">
      <div className="container">
        <div className="row">
          <h1>Players</h1>
          <PlayersList players={players} />
        </div>
      </div>
    </Page>
  )
}

const mapStateToProps = (state) => {
  const { players } = state.user.data || {}
  return {
    players: players || [],
  }
}

export default connect(mapStateToProps)(Players)
